import React from 'react'
import { Container, DifficultyName, NumberOfCards } from './styles'

export type DifficultyItemProps = {
  name: string
  numOfCards: number
  className?: string
  isSelected?: boolean
  onClick?: () => void
}

const DifficultyItem: React.FC<DifficultyItemProps> = (props) => {
  const { name, numOfCards, className, onClick, isSelected = false } = props
  const numOfCouples = numOfCards / 2

  return (
    <Container className={className} isSelected={isSelected} onClick={onClick}>
      <DifficultyName>{name}</DifficultyName>
      <NumberOfCards>{numOfCouples}組</NumberOfCards>
    </Container>
  )
}

export default DifficultyItem
